// Library
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { faRedo } from '@fortawesome/free-solid-svg-icons';

// Data
import hobbies from 'data/hobbies';
import products from 'data/products';

// Components
import Hobby from 'components/Hobby';
import Button from 'components/elements/Button';
import KakaoShareButton from 'components/elements/KakaoShareButton';

const MainWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  .ribbon {
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 56px;
    font-weight: 500;
  }
  .inner {
    @media only screen and (max-width: 500px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    @media only screen and (min-width: 501px) {
      padding-top: 80px;
      max-width: 500px;
    }
    width: 100%;
    margin: 0 auto;
    padding: 48px 20px;
    box-sizing: border-box;
    .title-wrapper {
      text-align: center;
      .img {
        width: 56px;
        margin: 0 auto 20px;
        display: block;
      }
      h4 {
        margin: 20px 0 10px;
        font-weight: 800;
      }
      h1 {
        display: inline-block;
        margin: 0 0 48px;
        padding-bottom: 10px;
        font-weight: 700;
        letter-spacing: -2px;
        border-bottom: 1px dotted #3c5975;
      }
    }
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  button {
    width: 100%;
  }
  & > * {
    flex: 1;
  }
  & > :last-child {
    margin-left: 10px;
  }
`;

const Footer = styled.div`
  padding: 0 20px 80px;
  text-align: center;
  div {
    font-size: 10.5px;
    color: rgba(0, 0, 0, 0.54);
  }
`;

const Result = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getProductsByHobby = (hobby) => {
    let productArray = [];
    products.forEach((product) => {
      if (product.hobbyId === hobby.id) {
        productArray.push(product);
      }
    });
    return productArray;
  };
  return (
    <MainWrapper>
      <div className="ribbon navy-bg gana">집콕 취미 찾기</div>
      <div className="inner">
        <div>
          {hobbies.map((hobby, index) => (
            <Hobby
              hobby={hobby}
              key={index}
              products={getProductsByHobby(hobby)}
            />
          ))}
        </div>
        <ButtonWrapper>
          <Link to="/">
            <Button label={'테스트 다시하기'} icon={faRedo} />
          </Link>
          <KakaoShareButton
            className="btn-lg"
            label={'테스트 공유하기'}
            url={'https://untacthobby.web.app'}
          />
        </ButtonWrapper>
      </div>
      <Footer>
        <div>파트너스 활동을 통해 일정액의 수수료를 제공받을 수 있습니다.</div>
        <div>이 사이트에는 가나초콜릿체가 사용되었습니다.</div>
      </Footer>
    </MainWrapper>
  );
};

export default Result;
